var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "e4108f92-ad17-47d9-a715-54cf643fc999"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a8918422-3d6e-45e3-baa0-90daade2aef3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 562.05 438.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-350, -280)",
    d: "M 329.62 33.602 C 323.4325 33.602 318.421 38.617599999999996 318.41700000000003 44.800999999999995 L 318.41700000000003 248.421 L 114.79700000000003 248.421 L 114.80090600000003 248.421 C 108.61340600000003 248.421 103.60190600000003 253.4366 103.60190600000003 259.62 L 103.60190600000003 300.331 C 103.60190600000003 306.5185 108.61360600000003 311.53000000000003 114.80090600000003 311.534 L 318.42090600000006 311.534 L 318.42090600000006 515.204 L 318.41699900000003 515.204 C 318.42090600000006 521.3875999999999 323.43259900000004 526.4029999999999 329.619999 526.4029999999999 L 370.330999 526.4029999999999 C 376.51459900000003 526.4029999999999 381.52999900000003 521.3874 381.52999900000003 515.204 L 381.52999900000003 311.534 L 585.199999 311.534 C 591.387499 311.530094 596.398999 306.5184 596.398999 300.331 L 596.398999 259.62 C 596.398999 253.4364 591.387299 248.421 585.199999 248.421 L 381.5299990000001 248.421 L 381.5299990000001 44.80099999999999 C 381.5299990000001 38.61739999999999 376.5143990000001 33.60199999999999 370.3309990000001 33.60199999999999 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFull);
export default __webpack_public_path__ + "static/media/PlusFULL.4d5bc9a1a8acab86603529489861ee69.svg";
export { ForwardRef as ReactComponent };